import React from "react";
import { Grid, InputLabel, Typography } from "@mui/material";

export const PoolingAdministrator = () => {
    return (
        <>
            <Grid item xs={12}><InputLabel>Pooling Administrator:</InputLabel></Grid>
            <Grid item xs={12}>
                <Typography>CNA, 880 Taylor Creek Drive, Room 102</Typography>
                <Typography>Orleans, ON, K4A 0Z9</Typography>
                <Typography>Phone: 613-702-0016, Fax: 613-702-0017, E-Mail: NPAC-CNA@cnac.ca</Typography>
            </Grid>
        </>
    );
};